import {ExperimentCollectionType} from 'apps/experiments/src/types';

import {CollectionMethodExposureEvents} from './exposure-events';

export const CollectionMethodComponents = {
  [ExperimentCollectionType.EXPOSURE_EVENTS]: CollectionMethodExposureEvents,
};
